import { z } from 'zod';

export const orgAdminClassroomListQuerySchema = z.object({
  teacherId: z.string().cuid().optional(),
  includeExpired: z
    .enum(['true', 'false'])
    .optional()
    .transform((val) => (val ? val === 'true' : true)),
  source: z
    .enum(['all', 'teacher', 'admin', 'clever'])
    .optional()
    .default('all'),
  search: z
    .string()
    .trim()
    .max(100)
    .optional()
    .transform((value) => (value && value.length > 0 ? value : undefined)),
  sortBy: z
    .enum(['classroom', 'teacher', 'students', 'status'])
    .optional()
    .default('status'),
  sortOrder: z.enum(['asc', 'desc']).optional().default('asc'),
  page: z.coerce.number().int().positive().optional().default(1),
  pageSize: z.coerce.number().int().positive().max(100).optional().default(20),
});
